"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getKeyAssetIdFromVideos(videos) {
  if (!videos || !videos.length) {
    return null;
  }

  var _videos$ = videos[0],
      assetIds = _videos$.assetIds,
      outputs = _videos$.outputs;
  var initialAssetId = assetIds && assetIds.length ? assetIds[0] : null;

  if (!outputs || !outputs.length) {
    return initialAssetId;
  }

  var master = outputs.find(function (_ref) {
    var isMaster = _ref.isMaster;
    return isMaster;
  });

  if (!master) {
    return initialAssetId;
  }

  var versions = master.versions;

  if (!versions || !versions.length) {
    return initialAssetId;
  }

  var assetId = versions[versions.length - 1].assetId;

  if (!assetId) {
    return initialAssetId;
  }

  return assetId;
}

var _default = getKeyAssetIdFromVideos;
exports.default = _default;